// @ts-nocheck
import React, { useState, useEffect } from "react";
import ListaDeDifusiones from "./Componentes/ListaDeDifusiones";
import { AgregarDifusionButton } from "./Componentes/agregar-difusion/AgregarDifusionButton";
import { FirmaButton } from "./Componentes/firma/FirmaButton";
import { useAuth } from "../Auth/State/AuthContext";
import {
  Box,
  Grid,
  Typography,
} from '@mui/material';

export const DifusionesConsulta = () => {
  const { hasRole } = useAuth();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "stretch",
          gap: 4,
          marginTop: "30px",
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between" paddingX="20px">
          <Typography variant="h4">
            Difusiones
          </Typography>
          <Box display="flex" gap={1}>
            {hasRole(["ROLE_CREAR_DIFUSION"]) && hasRole(["ROLE_ENVIAR_DIFUSION"]) ? (
              <AgregarDifusionButton />
            ) : null}
            {hasRole(["ROLE_VER_FIRMA"]) ? (
              <FirmaButton />
            ) : null}
          </Box>
        </Box>
        <Box>
          {hasRole(["ROLE_OBTENER_DIFUSIONES"]) && (<ListaDeDifusiones />)}
        </Box>
      </Box>
    </>
  );
};
